import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Leaf } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: '🧠',
    text: <>
          <strong className="text-[#4A5D3A]" data-id="element-14">
            Apagarás el bucle de pensamientos
          </strong>{' '}
          en minutos — no porque te fuerces, sino porque le darás a tu cerebro
          la señal química que necesita para soltar
        </>
  }, {
    icon: '😴',
    text: <>
          <strong className="text-[#4A5D3A]" data-id="element-15">Dormirás sin pastillas</strong> que
          te dejen aturdida justo cuando más necesitas estar presente y entera
        </>
  }, {
    icon: '🌅',
    text: <>
          <strong className="text-[#4A5D3A]" data-id="element-16">Despertarás diferente</strong> —
          sin esa presión en el pecho que ya normalizaste sin darte cuenta
        </>
  }, {
    icon: '💚',
    text: <>
          <strong className="text-[#4A5D3A]" data-id="element-17">
            Recuperarás tu versión calmada
          </strong>{' '}
          — la que no depende de cuánto dormiste, sino de cómo tu sistema
          nervioso llega al día
        </>
  }, {
    icon: '🛡️',
    text: <>
          <strong className="text-[#4A5D3A]" data-id="element-18">
            Tendrás un protocolo de emergencia
          </strong>{' '}
          para los días en que el caos explota — listo, simple, en tu cocina
        </>
  }, {
    icon: '🌸',
    text: <>
          <strong className="text-[#4A5D3A]" data-id="element-19">
            Dejarás de sentirte "demasiado sensible"
          </strong>{' '}
          — porque finalmente entenderás que tu cuerpo no estaba fallando. Solo
          estaba esperando las instrucciones correctas.
        </>
  }, {
    icon: '💰',
    text: <>
          <strong className="text-[#4A5D3A]" data-id="element-20">
            Gastarás menos de $5 USD en plantas
          </strong>{' '}
          que ya puedes conseguir en tu supermercado local — esta semana, hoy
          mismo
        </>
  }];
  return <section className="px-6 py-10 max-w-4xl mx-auto" data-id="element-21">
      <FadeIn data-id="element-22">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#2D2A26] mb-8" data-id="element-23">
          Cuando apliques el Método de Rescate Botánico:
        </h2>

        <div className="space-y-4" data-id="element-24">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4 md:gap-6 bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-[#4A5D3A]/10" data-id="element-25">
              <div className="text-3xl md:text-4xl shrink-0 bg-[#FAF6F0] w-14 h-14 rounded-full flex items-center justify-center" data-id="element-26">
                {benefit.icon}
              </div>
              <p className="text-lg md:text-xl text-[#2D2A26]/90 leading-relaxed pt-1 md:pt-2" data-id="element-27">
                {benefit.text}
              </p>
            </div>)}
        </div>
      </FadeIn>
    </section>;
}